export default "__VITE_ASSET__a39fb547__"